import React, { Component } from "react";

// React router
import { withRouter } from "react-router-dom";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Dependencies
import _ from "lodash";
import PropTypes from "prop-types";

// Material ui
import { withStyles, Paper, Tabs, Tab, Typography, Box } from "@material-ui/core";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import { CreateBubble, OrderBubbles } from "./components/index";

import { fetchConnections } from "../../redux/actions/connectionActions";

import styles from "./styles";
import { triggerBotBuilding } from "../../redux/actions/intentsActions";
import { pushMessage, removeMessage } from "../../redux/actions/commonActions";


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

class Connections extends Component {
  signal = true;

  state = {
    isLoading: false,
    limit: 6,
    products: [],
    productsTotal: 0,
    error: null,
    search: "",
    loaded: false,
    connections: {},
    disabled: false,
    tabSelected: 0
  };

  async getConnections() {
    try {
      this.setState({ isLoading: true });
      // console.log("Check bot status");
      await this.props.fetchConnections();
      this.setState({ isLoading: false, loaded: true });
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error
        });
      }
    }
  }

  componentWillMount() {
    this.signal = true;
    this.getConnections();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  componentWillReceiveProps(newProps, oldProps) {
    const enabledConnections = newProps.connections["enabled"] ? newProps.connections["enabled"] : [];
    const filteredFaQ = enabledConnections.filter(connection => {
      if (connection.compositeKey === "faq") {
        return connection;
      }
    });
    this.setState({ connections: filteredFaQ });
  }

  filterConnections = (event, val) => {
    this.setState({ search: event.target.value });
    let connectionLists = [...this.state.connections];
    console.log(connectionLists);
    _.forEach(connectionLists, connection => {
      connection.visible = _.includes(connection.connectorName.toLowerCase(), event.target.value.toLowerCase());
    });
    this.setState({ connections: connectionLists });
  };

  triggerParent = connection => {
    this.setState({ selectedConnection: connection });
  };

  
  handleChange = (event, newValue) => {
    console.log(event)
    this.setState({ tabSelected: newValue});
  };

  render() {
    const { classes, skill } = this.props;
    const { tabSelected} = this.state;

    const enabled = this.state.connections ? this.state.connections : [];

    return (

      <DashboardLayout title="Bubbles" isLoading={this.state.isLoading}>
        <Paper>
            <Tabs
                  value={tabSelected}
                  indicatorColor="primary"
                  textColor="primary"
                  aria-label="nav tabs example"
                  className={classes.tabRoot}
                  onChange={this.handleChange}
                >
                  <Tab label="Edit Bubbles" {...a11yProps(0)}/>
                  <Tab label="Order Bubbles" {...a11yProps(1)}/>
            </Tabs>
            <TabPanel value={tabSelected} index={0}>
              <Box className={classes.tabContainer} >
                <Grid item xs={12}>
                  
                  <CreateBubble
                    selectedConnection={this.state.selectedConnection}
                    skill={this.props.skill}
                    administrator={this.props.administrator}
                  />
                </Grid>
              </Box>
            </TabPanel>
            <TabPanel value={tabSelected} index={1}>
              <Paper className={classes.tabContainer} elevation={1} >
                <Grid item xs={12}>
                  <OrderBubbles selectedConnection={this.state.selectedConnection} skill={this.props.skill} />
                </Grid>
              </Paper>
            </TabPanel>
        </Paper>

      </DashboardLayout>
    
    )
}}

Connections.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchConnections: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    connections: state.connections ? state.connections : {},
    skill: state.skill,
    botBuilt: state.intents["botBuilt"] ? state.intents.botBuilt : {},
    botStatus: state.intents["botStatus"] ? state.intents.botStatus : {},
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false,
    message: state.common.message,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchConnections,
        triggerBotBuilding,
        removeMessage,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Connections))
);
